import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, Suspense } from 'react';
import SignIn from './components/SignIn';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import NotFound from './components/NotFound';
import MainPage from './components/MainPage';
import LinkContext from './context/LinkContext'

function App() {

  const [reloadToggle, setReloadToggle] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("/");

  const setCurUrl = (url) => {
    setCurrentUrl(url);
  }

  const receiveReloadToggle = () => {
    setReloadToggle(!reloadToggle);
  };

  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
        <LinkContext.Provider
          value={{
            curUrl: currentUrl,
            setUrl: setCurUrl
          }}
        >
          <Routes>
            <Route path="/records/*" element={<MainPage />} />
            <Route path="/" element={<Navigate replace to="/records" />} />

            <Route path="/sign-in" element={<SignIn onHandleChange={receiveReloadToggle} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </LinkContext.Provider>
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default App;
